import React from "react";
import "./DownloadPlatform.css";

const DownloadPlatform = () => {
  const handleDownloadMT5 = () => {
    window.open("https://www.metatrader5.com/en/download", "_blank");
  };

  const handleDownloadMT4 = () => {
    window.open("https://www.metatrader4.com/en/download", "_blank");
  };

  return (
    <div className="downloadplatform">
      <div className="divsec-title">
        <div className="divsec-title1">
          <div className="heading-2">
            <h1 className="trading-platform">Trading Platform</h1>
          </div>
        </div>
      </div>
      <div className="divfooter-download">
        <div className="divfooter-download1">
          <button className="dwnbtn" onClick={handleDownloadMT4}>
            <div className="section-contact-us">
              <img
                className="downloading-updates-icon"
                loading="lazy"
                alt=""
                src="/downloading-updates@2x.png"
              />
              <b className="download">Download MT4</b>
            </div>
          </button>
          <button className="button1" onClick={handleDownloadMT5}>
            <div className="section-contact-us">
              <img
                className="downloading-updates-icon"
                loading="lazy"
                alt=""
                src="/downloading-updates@2x.png"
              />
              <b className="download">Download MT5</b>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadPlatform;
